// Fuente única de verdad de los logos de marca de Kaizen Feedback.
//
// Los assets viven aquí una sola vez (`assets/`). Las apps consumen estos
// imports estáticos de Next (StaticImageData), de modo que el próximo cambio de
// logo o de proporciones se resuelve sustituyendo UN fichero en `assets/`, sin
// tocar ningún componente ni ruta literal repartida por el monorepo.
//
// Uso:
//   import { logoCompleto } from "@kaizen/brand";
//   <Image src={logoCompleto} alt="Kaizen Feedback" width={180} height={50} />
//   <img src={logoCompleto.src} ... />           // <img> plano / render a imagen
//   `${SITE_URL}${logoCompleto.src}`              // URL absoluta (JSON-LD / OG)
//
// Requiere `transpilePackages: ["@kaizen/brand"]` en el next.config de la app,
// para que Next resuelva los imports `.png` a StaticImageData.

import logoCompleto from "./assets/logo-completo.png";
import logoCuadrado from "./assets/logo-cuadrado.png";

export { logoCompleto, logoCuadrado };
